export{cva as cnVariant}from"class-variance-authority";import{clsx as a}from"clsx";const r=(...r)=>a(r);export{r as cnJoin};
